export default function FAQSection() {
  return (
    <div className="max-w-4xl mx-auto mt-10">
      <h1 className="text-left mb-6">Frequently Asked Questions (FAQ)</h1>

      <div className="space-y-6 text-left">
        <FAQItem
          index="1."
          q="How do I upgrade my plan?"
          a="Contact our admin and we will manually upgrade your plan after payment is confirmed."
        />
        <FAQItem
          index="2."
          q="If I cancel, do I get a refund?"
          a="No. Cancelling early does not result in any prorated refund."
        />
        <FAQItem
          index="3."
          q="Can I cancel anytime?"
          a="Yes, cancellations can be done manually by contacting our support team."
        />
        <FAQItem
          index="4."
          q="What payment methods are accepted?"
          a="Currently we accept manual Bank Transfer, QR payment or Cash. Online gateway is not available yet."
        />
      </div>
    </div>
  );
}

const FAQItem = ({ index, q, a }) => (
  <div>
    <p className="font-semibold text-gray-900">{index} {q}</p>
    <p className="text-gray-600 mt-1 ml-6">{a}</p>
  </div>
);
